import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from './Navbar/NavBar';
import img from '../images/logo.jpg';
import {Helper} from '../static/helper';

const Accueil = () => {
    return (
        <>
            <div className="Accueil" id='Accueil'>
                <div>
                    <NavBar />
                </div>
                
                <div className="m-auto overflow-hidden mx-4 mt-16 lg:mt-4 p-2 md:p-12 h-5/6" data-aos="zoom-in">

                    <div id='Accueil' style={{display: "flex", alignItems:"center"}} className="flex-col lg:flex-row py-8 text-center lg:text-left">
                        <div className="lg:w-1/2 flex flex-col justify-center" data-aos="zoom-in" data-aos-delay="200">
                            <h1 className="mb-5 text-2xl sm:text-3xl md:text-5xl font-bold" style={{color : Helper.footerBackGroundColor}}>
                               Qu'est ce que la chiropraxie ?
                            </h1>
                            <div className="text-base sm:text-lg lg:text-xl font-semibold tracking-tight mb-5 text-gray-500">
                            La chiropraxie est une profession de santé spécialisée dans la détection, le traitement et la prévention des dysfonctionnements des différents systèmes présents dans notre corps (nerveux, musculaire et osseux), en particulier ceux affectant la colonne vertébrale.
                            </div>

                            <div className="w-full sm:w-72 pt-6 mx-auto lg:mx-0">
                                <Link to="/Chiropraxie" style={{background:Helper.footerBackGroundColor}} className="text-white justify-center text-center rounded-lg px-10 py-3 flex items-center group">En savoir plus !
                                </Link>
                            </div>
                        </div>
                        <div className="flex justify-center lg:justify-end w-full lg:w-1/2 mt-8 lg:mt-0" data-aos="fade-up" data-aos-delay="700">
                            <img alt="card img" className="rounded-t duration-1000 w-full max-w-xs sm:max-w-sm lg:max-w-md" src={img} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Accueil;